// ------------------------REGARDING FOR STATIC CONTENT  ------------------------------------------
import logoImage from '../assets/images/logo.png'; 
const websiteName = "mobilACD";  
const websiteTagline = "Engineering the Road Ahead.";  
const websiteUrl = "https://www.mobilACD.com";  
const logoUrl = logoImage;
const androidAppLink = "android-app://com.mobilACD.sura_user";
const iosAppLink = "ios-app://com.mobilACD.sura_user";    
const currentLocation = sessionStorage.getItem('country');  
const currencyIcon = currentLocation === 'India' ? '₹' : '$';


// ----------------------- REGARDING FOR SEO / META TAG   -----------------------------------------------
window.logoUrl = logoImage;
window.dynamicAndroidAppLink = "https://play.google.com/store/apps/details?id=com.example";
window.dynamicIosAppLink = "https://apps.apple.com/us/app/example/id123456789";
window.dynamicWebsiteName = websiteName;
window.websiteTagline = 'Engineering the Road Ahead.';
window.websiteUrl = 'https://www.mobilACD.com';
window.metaOgDescription = `Discover ${websiteName}, your trusted partner in the automobile industry, offering comprehensive services to keep your vehicle in top condition for a smoother and safer drive...`;
window.metatwitterDescription = `Discover ${websiteName}, your trusted partner in the automobile industry, supporting your journey to a smoother and safer driving experience...`;
const metaDescriptionEn = `Discover ${websiteName}, your trusted partner in the automobile industry, offering personalized care and comprehensive services to enhance your vehicle's performance and longevity...`;
const metaDescriptionTh = `ค้นพบ ${websiteName} พันธมิตรที่คุณวางใจในอุตสาหกรรมยานยนต์, ให้บริการดูแลแบบเฉพาะเจาะจงและครอบคลุมเพื่อเสริมสร้างประสิทธิภาพและอายุการใช้งานของรถยนต์ของคุณ...`;

const keywordsTemplate = {
    en: {
      static: "Legal Services, Financial Solutions, Expert Advice, Personalized Support",
      dynamic: `${websiteName}`
    },
    th: {
      static: "บริการด้านกฎหมาย, โซลูชั่นการเงิน, คำแนะนำจากผู้เชี่ยวชาญ, การสนับสนุนเฉพาะบุคคล",
      dynamic: `${websiteName}`
    }
  };




export {
  websiteName,
  websiteTagline,
  websiteUrl,
  logoUrl,
  currencyIcon,
  metaDescriptionEn,
  metaDescriptionTh,
  keywordsTemplate,
  androidAppLink,
  iosAppLink,
};